


import React, { useState, useEffect, useRef } from "react";
import "./navbar.css";
import { Link } from "react-router-dom";

import HamburgerMenu from "./HamburgerMenu";
import SearchInput from "./SearchInput";

const Navbar = () => {
  const [isInputActive, setInputActive] = useState(false);
  const inputRef = useRef(null);

  const handleSearchIconClick = () => {
    setInputActive(true);
  };

  const handleClickOutside = (event) => {
    if (inputRef.current && !inputRef.current.contains(event.target)) {
      setInputActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const [isMenuOpen, setMenuOpen] = useState(false);

  const handleMenuIconClick = () => {
    setMenuOpen(!isMenuOpen);
  };


  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  return (
    <nav className="nav_section">
      <div className={`nav_container ${scrolled ? 'scrolled' : ''}`}>
        <Link to='/'> 
        <img src="/assets/logo.svg" alt=""  />
        </Link>

        <div className="nav_div">
          <SearchInput/>
          <HamburgerMenu/>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;













































